import "./Header.css";
import {AuthContext} from "../../../context";
import React, { useState, useEffect, useRef, useContext } from "react";
import langBlueIcon from "../../../Assets/icons/language-blue.svg";
import profile_img from "../../../Assets/icons/profile_icon.svg";
import notify from "../../../Assets/icons/Notifications-icon.svg";
import profileIcon from "../../../Assets/icons/profile.svg";
import logoutIcon from "../../../Assets/icons/logout.svg";
import MyModal from "../MyModal/MyModal";
import {useNavigate} from "react-router-dom";
import error from '../../../Assets/icons/error.svg'
import success from '../../../Assets/icons/success.svg'

const Header = () => {
    const { logout } = useContext(AuthContext);
    const {uploadState, setUploadState} = useContext(AuthContext)

    const navigate = useNavigate();

    const [isLangDropdownOpen, setIsLangDropdownOpen] = useState(false);
    const [isProfileDropdownOpen, setIsProfileDropdownOpen] = useState(false);
    const [modal, setModal] = useState(false);

    const langRef = useRef(null);
    const profileRef = useRef(null);

    const check = () => {
        const now = new Date().toISOString();
        console.log(now);
    }

    const toggleLangDropdown = () => {
        setIsLangDropdownOpen((prev) => !prev);
    };

    const toggleProfileDropdown = () => {
        setIsProfileDropdownOpen((prev) => !prev);
    };

    const text = 'Log out from your account now?'
    const btnText = "Log out"

    // Close dropdowns when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (langRef.current && !langRef.current.contains(event.target)) {
                setIsLangDropdownOpen(false);
            }
            if (profileRef.current && !profileRef.current.contains(event.target)) {
                setIsProfileDropdownOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <div className='header-wrap' onClick={() => {check()}}>
            <MyModal
                visible={modal}
                setVisible={setModal}
                onClick={logout}
                text={text}
                btnText={btnText}
            />
            <div></div>
            {uploadState !== null && (
                <div className={`toast ${uploadState === 'true' ? 'success' : uploadState === 'false' ? 'error' : ''}`}>
                    {uploadState && (
                        <>
                            <img src={uploadState === 'true' ? success : error} alt={uploadState === 'true' ? "success" : "error"} />
                            <span>
                    {uploadState === 'true'
                        ? "You successfully created new accounts for students"
                        : "Invalid file to register students"}
                </span>
                        </>
                    )}
                </div>
            )}

            {/* Language Dropdown */}
            <div style={{width:232, display: 'flex', alignItems:'center', justifyContent:"space-between"}}>
                <div className="custom-dropdown" ref={langRef}>
                    <button className="dropdown-btn icon-only" onClick={toggleLangDropdown}>
                        <img src={langBlueIcon} alt="Language Icon" className="lang-icon" />
                    </button>

                    {isLangDropdownOpen && (
                        <ul className="dropdown-menu">
                            <li>English</li>
                            <li>Қазақ</li>
                            <li>Русский</li>
                        </ul>
                    )}
                </div>

                <img src={notify} alt="bell" className="bell" />

                {/* Profile Section */}
                <div className="profile-container" ref={profileRef}>
                    <div className="Profile" onClick={toggleProfileDropdown}>
                        <img className="profile_img" src={profile_img} alt="profile" />
                        <div className="name">
                            <div className="first">Name</div>
                            <div className="last">Surname</div>
                        </div>
                    </div>

                    {/* Profile Dropdown */}
                    {isProfileDropdownOpen && (
                        <div className="profile-dropdown" onClick={() => {
                            toggleProfileDropdown();
                        }}>
                            <div className="dropdown-item" onClick={() => {navigate("/profile");}}>
                                My profile
                                <img src={profileIcon} alt="Profile Icon" className="dropdown-icon" />

                            </div>
                            <div className="dropdown-item logout" onClick={() => setModal(true)}>
                                Log out
                                <img src={logoutIcon} alt="Logout Icon" className="dropdown-icon" />

                            </div>
                        </div>
                    )}
                </div>
            </div>

        </div>
    );
};

export default Header;
